// Vehicle Status
export const FETCH_DEFAULT_REASONS = 'FETCH_DEFAULT_REASONS'
export const FETCH_VALID_STATUSES = 'FETCH_VALID_STATUSES'
// Alarms
// export const FETCH_SPEED_ALARMS_PUSHER = 'FETCH_SPEED_ALARMS_PUSHER'
export const FETCH_SPEED_ALARMS = 'FETCH_SPEED_ALARMS'
export const SET_LOADING_SPEED_ALARMS = 'SET_LOADING_SPEED_ALARMS'
export const FETCH_MISSION_ALARMS = 'FETCH_MISSION_ALARMS'
export const SET_LOADING_MISSION_ALARMS = 'SET_LOADING_MISSION_ALARMS'
export const UPDATE_MISSION_ALARMS = 'UPDATE_MISSION_ALARMS'
export const CLEAR_SPEEDS_ALARMS = 'CLEAR_SPEEDS_ALARMS'
export const CLEAR_MISSION_ALARMS = 'CLEAR_MISSION_ALARMS'
export const SET_JUSTIFICATION_IN_PROGRESS = 'SET_JUSTIFICATION_IN_PROGRESS'
export const UPDATE_SPEED_ALARMS = 'UPDATE_SPEED_ALARMS'
export const UPDATE_MOVEMENT_ALARMS = 'UPDATE_MOVEMENT_ALARMS'
export const FETCH_UNREPORTED_EVENTS_ALARMS = 'FETCH_UNREPORTED_EVENTS_ALARMS'
export const SET_LOADING_UNREPORTED_EVENTS_ALARMS = 'SET_LOADING_UNREPORTED_EVENTS_ALARMS'
export const UPDATE_UNREPORTED_EVENT_ALARMS = 'UPDATE_UNREPORTED_EVENT_ALARMS'
export const CLEAR_UNREPORTED_EVENT_ALARMS = 'CLEAR_UNREPORTED_EVENT_ALARMS'
export const SET_SHOW_AUTO_RELOAD_ALARM = 'SET_SHOW_AUTO_RELOAD_ALARM'
export const SET_SHOW_RELOAD_ALARMS_MESSAGE = 'SET_SHOW_RELOAD_ALARMS_MESSAGE'
export const SET_MISSION_ALERT_INTERVAL_INSTANCE = 'SET_MISSION_ALERT_INTERVAL_INSTANCE'
export const SET_CURRENT_JUSTIFICATIONS_IN_PROGRESS = 'SET_CURRENT_JUSTIFICATIONS_IN_PROGRESS'
export const SET_LOADING_PARKING_ALARMS = 'SET_LOADING_PARKING_ALARMS'
export const FETCH_PARKING_ALARMS = 'FETCH_PARKING_ALARMS'
export const UPDATE_PARKING_ALARMS = 'UPDATE_PARKING_ALARMS'
export const CLEAR_PARKING_ALARMS = 'CLEAR_PARKING_ALARMS'
export const SET_LOADING_GEOFENCE_IN_ALARMS = 'SET_LOADING_GEOFENCE_IN_ALARMS'
export const FETCH_GEOFENCE_IN_ALARMS = 'FETCH_GEOFENCE_IN_ALARMS'
export const UPDATE_GEOFENCE_IN_EVENT_ALARMS = 'UPDATE_GEOFENCE_IN_EVENT_ALARMS'
export const CLEAR_GEOFENCE_IN_ALARMS = 'CLEAR_GEOFENCE_IN_ALARMS'
// Vehicles
export const SELECT_VEHICLE = 'SELECT_VEHICLE'
export const UPDATE_VEHICLE_POSITION = 'UPDATE_VEHICLE_POSITION'
export const FETCH_VEHICLES = 'FETCH_VEHICLES'
export const SHOW_POINTS = 'SHOW_POINTS'
export const SHOW_POINTS_MESSAGE = 'SHOW_POINTS_MESSAGE'
export const ADD_VEHICLE_DATA = 'ADD_VEHICLE_DATA'
export const CONTROL_MESSAGE = 'CONTROL_MESSAGE'
export const REAL_TIME_VEHICLES = 'REAL_TIME_VEHICLES'
export const LAST_POSITIONS_INIT = 'LAST_POSITIONS_INIT'
export const SET_ALL_VEHICLES_UNFILTERED = 'SET_ALL_VEHICLES_UNFILTERED'
export const FILL_VEHICLE_DATA = 'FILL_VEHICLE_DATA'
export const FETCH_FILTERED_VEHICLES = 'FETCH_FILTERED_VEHICLES'
export const FETCH_FILTERED_VEHICLES_CONCAT = 'FETCH_FILTERED_VEHICLES_CONCAT'
export const ADD_LAST_POLYGONS_FILTER = 'ADD_LAST_POLYGONS_FILTER'
export const INIT_DATA_FILTERED = 'INIT_DATA_FILTERED'
export const ADD_GEOSTRING_FILTERS = 'ADD_GEOSTRING_FILTERS'
export const SHOW_LOADING_VEHICLE_DATA = 'SHOW_LOADING_VEHICLE_DATA'
export const FETCH_VEHICLE_TYPES = 'FETCH_VEHICLE_TYPES'
export const CHIP_SERIAL_YES_NOT = 'CHIP_SERIAL_YES_NOT'
export const ADD_VEHICLE_DATA_TEMP = 'ADD_VEHICLE_DATA_TEMP'
export const SEARCHING_VEHICLE = 'SEARCHING_VEHICLE'
export const SET_IGNITION_FILTER = 'SET_IGNITION_FILTER'
export const SET_STATE_VEHICLE_FILTER = 'SET_STATE_VEHICLE_FILTER'
export const SET_SEARCHED_VEHICLE_HOME = 'SET_SEARCHED_VEHICLE_HOME'
export const UP_VEHICLE = 'UP_VEHICLE'
export const UPDATE_VEHICLE = 'UPDATE_VEHICLE'
export const DOWN_VEHICLE = 'DOWN_VEHICLE'
export const SET_MAIN_AGENCY = 'SET_MAIN_AGENCY'
export const FILTER_APPLIED = 'FILTER_APPLIED'
export const UPDATE_STATUS_VEHICLE_DATA = 'UPDATE_STATUS_VEHICLE_DATA'
export const UPDATE_FILTER_CONDITION = 'UPDATE_FILTER_CONDITION'
export const SET_FILTER_CONDITION = 'SET_FILTER_CONDITION'
export const SET_CURRENT_MARKERS_LENGTH = 'SET_CURRENT_MARKERS_LENGTH'
export const SET_FILTER_BY_AZ = 'SET_FILTER_BY_AZ'
export const UPDATE_SELECTED_VEHICLE = 'UPDATE_SELECTED_VEHICLE'
export const ADD_ST2_SELECTED_VEHICLE = 'ADD_ST2_SELECTED_VEHICLE'
export const UPDATE_VEHICLE_STATUS_PUSHER = 'UPDATE_VEHICLE_STATUS_PUSHER'
export const SET_IN_MISSION_FILTER = 'SET_IN_MISSION_FILTER'
export const SET_IS_FILTERING = 'SET_IS_FILTERING'
export const UPDATE_VEHICLE_IN_MISSION_PUSHER = 'UPDATE_VEHICLE_IN_MISSION_PUSHER'
export const UPDATE_STATUSES_DEVICES_VEHICLE_DATA = 'UPDATE_STATUSES_DEVICES_VEHICLE_DATA'
export const UPDATE_IN_MISSION_DATA = 'UPDATE_IN_MISSION_DATA'
export const SET_IN_MISSION_DATA_FULL = 'SET_IN_MISSION_DATA_FULL'
export const SET_CANCEL_TOKEN_IN_MISSION_DATA = 'SET_CANCEL_TOKEN_IN_MISSION_DATA'
export const SET_INFO_WIN_OPEN = 'SET_INFO_WIN_OPEN'
// Missions
export const VEHICLES_WITHOUT_AGENCY = 'VEHICLES_WITHOUT_AGENCY'
export const FETCH_MISSIONS_TEMPLATES = 'FETCH_MISSIONS_TEMPLATES'
export const FETCH_MISSIONS_SERVICES = 'FETCH_MISSIONS_SERVICES'
export const REQUEST_MISSIONS_SERVICES = 'REQUEST_MISSIONS_SERVICES'
export const FETCH_MISSIONS_SERVICES_RAW = 'FETCH_MISSIONS_SERVICES_RAW'
export const UPDATE_MISSION_SERVICES_TERMINATE = 'UPDATE_MISSION_SERVICES_TERMINATE'
export const UPDATE_MISSION_SERVICES_DELETE = 'UPDATE_MISSION_SERVICES_DELETE'
export const UPDATE_MISSION_SERVICES_MODIFY_WHO = 'UPDATE_MISSION_SERVICES_MODIFY_WHO'
export const UPDATE_MISSION_SERVICES_MODIFY_WHEN = 'UPDATE_MISSION_SERVICES_MODIFY_WHEN'
export const UPDATE_MISSION_SERVICES_MODIFY_WHERE = 'UPDATE_MISSION_SERVICES_MODIFY_WHERE'
export const SET_SHOW_MESSAGE_RELOAD_REQUEST = 'SET_SHOW_MESSAGE_RELOAD_REQUEST'
export const SET_MISSIONS_SERVICES_DATE_TIME = 'SET_MISSIONS_SERVICES_DATE_TIME'
export const SET_SHOW_AUTO_RELOAD_ALERT = 'SET_SHOW_AUTO_RELOAD_ALERT'
export const SET_ACTIONS_IN_MISSION_PROGRESS = 'SET_ACTIONS_IN_MISSION_PROGRESS'
export const SET_MISSIONS_IN_MODIFICATION = 'SET_MISSIONS_IN_MODIFICATION'
export const SET_VEHICLES_IN_A_MISSION = 'SET_VEHICLES_IN_A_MISSION'
// Geofences
export const FETCH_GEOFENCES = 'FETCH_GEOFENCES'
export const SELECT_GEOFENCE = 'SELECT_GEOFENCE'
export const ADD_GEOFENCE = 'ADD_GEOFENCE'
export const UPDATE_GEOFENCE = 'UPDATE_GEOFENCE'
export const ADD_STACK_GEOFENCE = 'ADD_STACK_GEOFENCE'
export const REMOVE_STACK_GEOFENCE = 'REMOVE_STACK_GEOFENCE'
export const SHOW_CREATE_GEOFENCE = 'SHOW_CREATE_GEOFENCE'
export const DESELECT_GEOFENCE = 'DESELECT_GEOFENCE'
export const GEOFENCE_CREATED = 'GEOFENCE_CREATED'
export const SET_EDITING_GEOFENCE = 'SET_EDITING_GEOFENCE'
export const GEOFENCE_UPDATED = 'GEOFENCE_UPDATED'
export const SET_MESSAGE_GEOFENCE = 'SET_MESSAGE_GEOFENCE'
export const SET_SHOW_MESSAGE_GEOFENCE = 'SET_SHOW_MESSAGE_GEOFENCE'
export const SET_IS_UPDATING_FENCE = 'SET_IS_UPDATING_FENCE'
// Alerts
export const FETCH_ALERTS = 'FETCH_ALERTS'
export const ADD_ALERT = 'ADD_ALERT'
export const UPDATE_ALERT = 'UPDATE_ALERT'
export const SELECT_GROUP_ALERT = 'SELECT_GROUP_ALERT'
export const SET_LOADING_MOVEMENT_ALARMS = 'SET_LOADING_MOVEMENT_ALARMS'
export const CLEAR_MOVEMENT_ALARMS = 'CLEAR_MOVEMENT_ALARMS'
export const FETCH_MOVEMENT_ALARMS = 'FETCH_MOVEMENT_ALARMS'
export const SET_LOADING_VEHICLES_WITHOUT_EVENTS_3H_ALARMS = 'SET_LOADING_VEHICLES_WITHOUT_EVENTS_3H_ALARMS'
export const FETCH_VEHICLES_WITHOUT_EVENTS_3H_ALARMS = 'FETCH_VEHICLES_WITHOUT_EVENTS_3H_ALARMS'
export const CLEAR_VEHICLES_WITHOUT_EVENTS_3H_ALARMS = 'CLEAR_VEHICLES_WITHOUT_EVENTS_3H_ALARMS'
// Zones
export const FETCH_ZONES_FILTERS = 'FETCH_ZONES_FILTERS'
export const SET_NEIGHBORHOOD = 'SET_NEIGHBORHOOD'
export const SET_COMUNE = 'SET_COMUNE'
export const SET_QUADRANT = 'SET_QUADRANT'
export const SET_STATIONS = 'SET_STATIONS'
export const SET_DISTRICTS = 'SET_DISTRICTS'
export const SET_GALLERY_NEIGHBORHOOD = 'SET_GALLERY_NEIGHBORHOOD'
export const SET_GALLERY_COMUNE = 'SET_GALLERY_COMUNE'
export const SET_GALLERY_QUADRANT = 'SET_GALLERY_QUADRANT'
export const SET_GALLERY_STATIONS = 'SET_GALLERY_STATIONS'
export const SET_GALLERY_DISTRICTS = 'SET_GALLERY_DISTRICTS'
export const SET_MUNICIPALITY = 'SET_MUNICIPALITY'
export const SET_FULL_ZONES_MAP = 'SET_FULL_ZONES_MAP'
export const SET_FIREFIGHTERS = 'SET_FIREFIGHTERS'
export const SET_EMPAS = 'SET_EMPAS'
// Agencies
export const FETCH_AGENCIES_TREE = 'FETCH_AGENCIES_TREE'
export const AGENCY_SELECTED = 'AGENCY_SELECTED'
export const FETCH_AGENCIES_MAP = 'FETCH_AGENCIES_MAP'
export const FETCH_SUPER_PARENTS = 'FETCH_SUPER_PARENTS'
export const SET_AGENCIES_BASE = 'SET_AGENCIES_BASE'
export const SET_AGENCIES_MAP_OBJ = 'SET_AGENCIES_MAP_OBJ'
// Home
export const DISPLAY_FILTERS_HOME = 'DISPLAY_FILTERS_HOME'
export const ADD_FILTER_TYPE_HOME = 'ADD_FILTER_TYPE_HOME'
export const DISPLAY_APPLY_FILTERS_HOME = 'DISPLAY_APPLY_FILTERS_HOME'
export const SHOW_INIT_DIALOG = 'SHOW_INIT_DIALOG'
export const DISPLAY_CITY_LAYER = 'DISPLAY_CITY_LAYER'
// Reports
export const SET_DOWNLOAD_GSTR = 'SET_DOWNLOAD_GSTR'
export const SET_URL_GSTR = 'SET_URL_GSTR'
export const SET_DOWNLOAD_GSVR = 'SET_DOWNLOAD_GSVR'
export const SET_URL_GSVR = 'SET_URL_GSVR'
export const SET_VIEW_POINT_DATA = 'SET_VIEW_POINT_DATA'
export const SET_SHOW_RESULT = 'SET_SHOW_RESULT'
export const SET_URL_GLER = 'SET_URL_GLER'
export const SET_DOWNLOAD_GLER = 'SET_DOWNLOAD_GLER'
export const SET_URL_GCCR = 'SET_URL_GCCR'
export const SET_DOWNLOAD_GCCR = 'SET_DOWNLOAD_GCCR'
export const SET_DOWNLOAD_GGOAT = 'SET_DOWNLOAD_GGOAT'
export const SET_URL_GGOAT = 'SET_URL_GGOAT'
export const SET_DOWNLOAD_GGOAV = 'SET_DOWNLOAD_GGOAV'
export const SET_URL_GGOAV = 'SET_URL_GGOAV'
export const SET_URL_GRMAT = 'SET_URL_GRMAT'
export const SET_DOWNLOAD_GRMAT = 'SET_DOWNLOAD_GRMAT'
export const SET_URL_GRMAV = 'SET_URL_GRMAV'
export const SET_DOWNLOAD_GRMAV = 'SET_DOWNLOAD_GRMAV'
export const SET_URL_PAT = 'SET_URL_PAT'
export const SET_DOWNLOAD_PAT = 'SET_DOWNLOAD_PAT'
export const SET_URL_PAV = 'SET_URL_PAV'
export const SET_DOWNLOAD_PAV = 'SET_DOWNLOAD_PAV'
export const SET_DOWNLOAD_LHR = 'SET_DOWNLOAD_LHR'
export const SET_URL_LHR = 'SET_URL_LHR'
export const SET_URL_GGIARV = 'SET_URL_GGIARV'
export const SET_DOWNLOAD_GGIARV = 'SET_DOWNLOAD_GGIARV'
export const SET_URL_GGIART = 'SET_URL_GGIART'
export const SET_DOWNLOAD_GGIART = 'SET_DOWNLOAD_GGIART'
// Pusher
export const SET_PUSHER_REF = 'SET_PUSHER_REF'
// Notifications
export const SHOW_NOTIFICATION = 'SHOW_NOTIFICATION'
export const SET_NOTIFICATION = 'SET_NOTIFICATION'
export const SPLICE_NOTIFICATION_LIST = 'SPLICE_NOTIFICATION_LIST'
export const SET_NEXT_NOTIFICATION = 'SET_NEXT_NOTIFICATION'
// Official Zones
export const SET_DISPLAY_OFFICIAL_ZONE = 'SET_DISPLAY_OFFICIAL_ZONE'
export const CLEAR_PATH_OFFICIAL_ZONES = 'CLEAR_PATH_OFFICIAL_ZONES'
export const CLEAR_SELECTED_OFFICIAL_ZONES = 'CLEAR_SELECTED_OFFICIAL_ZONES'
export const CLEAR_ALL_OFFICIAL_POLYGONS = 'CLEAR_ALL_OFFICIAL_POLYGONS'
export const SET_SELECTED_OFFICIAL_ZONE = 'SET_SELECTED_OFFICIAL_ZONE'
export const SAVE_OFFICIAL_ZONES_HOME = 'SAVE_OFFICIAL_ZONES_HOME'
export const LOAD_OFFICIAL_ZONES_HOME = 'LOAD_OFFICIAL_ZONES_HOME'
export const SAVE_FROM_ROUTE = 'SAVE_FROM_ROUTE'
// Current Date Time
export const SET_CURRENT_DATE_TIME = 'SET_CURRENT_DATE_TIME'
// Places Search
export const SET_PLACE_SELECTED = 'SET_PLACE_SELECTED'
export const SET_PLACE_SELECTED_LOCATION = 'SET_PLACE_SELECTED_LOCATION'
// Heat Map
export const SET_HEAT_MAP_DIALOG = 'SET_HEAT_MAP_DIALOG'
// Logs History
export const SET_MODEL_TYPE_SEARCHED_FILTERS = 'SET_MODEL_TYPE_SEARCHED_FILTERS'
export const SET_PAYLOAD_SEARCHED_FILTERS = 'SET_PAYLOAD_SEARCHED_FILTERS'
export const INIT_PAYLOAD_SEARCHED_FILTERS = 'INIT_PAYLOAD_SEARCHED_FILTERS'
export const INIT_MODEL_TYPE_SEARCHED_FILTERS = 'INIT_MODEL_TYPE_SEARCHED_FILTERS'
// SOS Alerts
export const SET_SOS_ALERT_ACTIVE = 'SET_SOS_ALERT_ACTIVE'
export const SET_SOS_ALERT_DATA = 'SET_SOS_ALERT_DATA'
export const SET_SOS_ALERT_TIMESTAMP = 'SET_SOS_ALERT_TIMESTAMP'
export const ADD_SOS_ALERT_TO_QUEUE = 'ADD_SOS_ALERT_TO_QUEUE'
export const REMOVE_CURRENT_SOS_ALERT = 'REMOVE_CURRENT_SOS_ALERT'
export const SET_CURRENT_ALERT_INDEX = 'SET_CURRENT_ALERT_INDEX'
export const CLEAR_SOS_ALERT_QUEUE = 'CLEAR_SOS_ALERT_QUEUE'
export const TRIGGER_NEW_ALERT_SOUND = 'TRIGGER_NEW_ALERT_SOUND'



// WEBPACK FOOTER //
// ./src/store/mutations-types.js